import type { TerrainView } from '../api/catalog';
import { ca } from '../i18n/ca';

/**
 * Where a world comes from, in words.
 *
 * The scan stores `source` as the folder it walked: "vanilla", a `@mod` folder
 * name, or the string "workshop:<id>". That is the identifier the panel and the
 * Workshop are addressed by and it stays in the database, but a reader looking
 * for CUP Terrains should not have to recognise a nine-digit number. The mod's
 * own name is read from its `meta.cpp` or `mod.cpp` during the scan; when it
 * carries neither, the Workshop id is still better than the folder.
 */
export function terrainOrigin(
  t: Pick<TerrainView, 'modName' | 'modWorkshopId' | 'source'>,
): string {
  if (t.modName) return t.modName;
  if (t.modWorkshopId) return ca.catalogPage2.terrainWorkshop(t.modWorkshopId);
  if (!t.source || t.source === 'vanilla') return ca.catalogPage2.terrainVanilla;
  return t.source;
}
